import React, { useEffect, useState } from "react";
import product from "../../assets/product.png";
import calender from "../../assets/calender.png";
import done from "../../assets/done.png";
import statusIcon from "../../assets/orders/status.png";
import { Button, Modal, Radio, Space } from "antd";
import Preparing from "../MyOrders/Preparing";
import Received from "./Received";
import GettingReadyPreview from "./GettingReadyPreview";
import prev from "../../assets/previewRequests/prev.png";
import { updatePreviewFunction } from "../../redux/previewsUpdateSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchPreviewId } from "../../redux/showPreviewIdSlice";
import { useTranslation } from "react-i18next";

const PreviewRequestsInProgress = ({
  id,
  isoDate,
  statuss,
  description,
  addresss,
  area,
  levels_count,
  units_count,
  construction_type,
  vdate,
  vtime,
  CompName,
  admin_id,
  pre_cost_tax,
  exp_cost_tax,
  pre_cost_tax_old,
  reason,
  back_tax,
  depositTax,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCancel, setIsModalCancel] = useState(false);
  const [orderStatus, setOrderStatus] = useState("approved");

  const dispatch = useDispatch();

  const showModal = (status) => {
    setOrderStatus(status);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModalCancel = () => {
    setIsModalCancel(true);
  };
  const handleOkCancel = () => {
    setIsModalCancel(false);
  };
  const handleCancelCancel = () => {
    setIsModalCancel(false);
  };

  const { showPreviewId, status, error } = useSelector(
    (state) => state.showPreviewId
  );

  useEffect(() => {
    dispatch(fetchPreviewId(id));
  }, [dispatch]);

  const renderModalContent = () => {
    // if (statuss === "approved" || statuss === "paid_10") {
    //   return (
    //     <Received
    //       id={id}
    //       date={formattedDate}
    //       time={formattedTime}
    //       description={description}
    //       addresss={addresss}
    //       area={area}
    //       levels_count={levels_count}
    //       units_count={units_count}
    //       statuss={statuss}
    //       images={showPreviewId}
    //       construction_type={construction_type}
    //       vdate={vdate}
    //       vtime={vtime}
    //       admin_id={admin_id}
    //       pre_cost_tax={pre_cost_tax}
    //       exp_cost_tax={exp_cost_tax}
    //       reason={reason}
    //     />
    //   );
    // }
    // if (statuss === "approved" || statuss === "paid_10") {
    return (
      <GettingReadyPreview
        id={id}
        date={formattedDate}
        time={formattedTime}
        description={description}
        addresss={addresss}
        area={area}
        levels_count={levels_count}
        units_count={units_count}
        statuss={statuss}
        // statuss="approved"
        images={showPreviewId}
        construction_type={construction_type}
        vdate={vdate}
        vtime={vtime}
        admin_id={admin_id}
        pre_cost_tax={pre_cost_tax}
        exp_cost_tax={exp_cost_tax}
        reason={reason}
        back_tax={back_tax}
        depositTax={depositTax}
        pre_cost_tax_old={pre_cost_tax_old}
      />
    );
    // }
  };

  const [value, setValue] = useState(1);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const dateObject = new Date(isoDate);

  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const year = dateObject.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  const hours = dateObject.getHours();
  const minutes = dateObject.getMinutes();

  const formattedTime = `${hours}:${minutes}`;

  return (
    <div>
      <div className="bg-white shadow-2xl rounded-2xl mt-4 p-4">
        <div className="flex justify-between ">
          <div className="lg:flex items-center">
            <img src={prev} className="w-[100px] rounded-2xl" />
            <p className="ml-3 text-[#737E91] font-semibold max-lg:mt-3">
              {t("Order number")}
              <span className="text-[#283D63] font-semibold">#{id}</span>
              <div className="flex items-center mt-3">
                <img
                  src={calender}
                  className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#283D63] font-medium">
                  {formattedDate} | {formattedTime}
                </p>
              </div>
              <div className="flex items-center mt-3">
                <img
                  src={statusIcon}
                  className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#737E91]">{t("Status")}</p>
                <p
                  className={`text-[#283D63] ${
                    language == "en" ? "ml-2" : "mr-2"
                  }`}
                >
                  {statuss}
                </p>{" "}
              </div>
            </p>
          </div>
        </div>

        <div className="flex justify-center my-5">
          <div>
            <button
              onClick={() => showModal("approved")}
              className="bg-[#FE9B71] text-white rounded-full px-8 max-lg:px-3 h-10 mx-3"
            >
              {t("View request")}
            </button>
            <Modal
              title={t("Request View")}
              className="orderModal"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
            >
              <div className="mt-6">{renderModalContent()}</div>
            </Modal>
          </div>

          <div>
            <button
              onClick={showModalCancel}
              className="text-[#FE9B71] rounded-full h-10 border-2 border-[#FE9B71] px-8 max-lg:px-3"
            >
              {t("Cancel Preview")}
            </button>
            <Modal
              title={t("Are you sure you want to cancel?")}
              className="orderModal orderModalPricing w_small_modal"
              open={isModalCancel}
              onOk={handleOkCancel}
              onCancel={handleCancelCancel}
              footer={null}
            >
              <form
                className="mx-5 my-5"
                onSubmit={(e) => {
                  e.preventDefault();
                  dispatch(
                    updatePreviewFunction({
                      status: "cancelled",
                      construction_preview_id: id,
                      cancel_reason: value,
                    })
                  );
                  setIsModalCancel(false);
                }}
              >
                <p className="text-[#A6ADB9] text-center">
                {t("No refund is available after team visit")}
                </p>

                <button
                  type="submit"
                  className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
                >
                  {t("Cancel Preview")}
                </button>
              </form>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewRequestsInProgress;
